const Routes = {
  home: { title: 'home', path: '/' },
  login: { title: 'login', path: '/login' },
  register: { title: 'register', path: '/register' },
  registerSuccess: { title: 'registerSuccess', path: '/register/notice' },
  verifyAccount: { title: 'verifyAccount', path: '/verify/:email/:token' },
  acceptInvite: { title: 'acceptInvite', path: '/invite/:email/:token' },
  forgotPassword: { title: 'forgotPassword', path: '/forgot' },
  resetPassword: { title: 'resetPassword', path: '/reset/:email/:token' },
  settings: { title: 'settings', path: '/settings' },
  profilepage: { title: 'profilepage', path: '/profilepage' },
  user: { title: 'user', path: '/user' },
  devices: { title: 'devices', path: '/devices' },
  search: { title: 'search', path: '/search' },
  logout: { title: 'logout', path: '/logout' },
  project: {title: 'project', path: '/project/:id'}
};

export default Routes;
